import React from 'react';
import AuthDispatchContext from './AuthDispatchContext';
import { useHistory } from 'react-router'

// TODO : これをブラウザーのURLが変わったときにチェックするように変更する
//        → Viewerクラスに依存しないようにする
export default function useAuthParser(location, moveTo)
{
    const dispatch = React.useContext(AuthDispatchContext);
    const history = useHistory();

    React.useEffect(() => {
        const hash = location && location.hash;
        if (hash) {
            var parsedToken = hash.substring(1);
            dispatch({type:"SET", value: parsedToken});
            if (!moveTo) {
                moveTo = location.pathname;
            }
            history.push(moveTo);
        }
    }, [location, dispatch, history]);
}